import { UserRole } from "@/common/enum/user-role";
import { useRecoilValue } from "recoil";
import { profileState } from "../atoms/user/profile-state";
import { AdminMainRouter } from "./AdminMainRouter";
import { PartnerMainRouter } from "./PartnerMainRouter";
import { SUMainRouter } from "./SUMainRouter";

//TODO 상품관리 path쪽 강조처리

export const MainRouter = () => {
  const profile = useRecoilValue(profileState);

  if (profile.role === UserRole.SUPERUSER) {
    return <SUMainRouter />;
  }

  if (profile.role === UserRole.ADMIN) {
    return <AdminMainRouter />;
  }

  return <PartnerMainRouter />;
};
